export const style = {
  Box: {
    sx: {
      display: 'flex',
      alignItems: 'center',
      p: 2,
    },
  },
} as const;
